import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState, useRef } from 'react';
import moment from 'moment';
import { DABInlineLoading } from '.';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { episodeAction } from '../../actions/episodeAction';

interface IUserProps {
	dispatch: Dispatch<any>;
	episodeData: any;
}

const UserEpisodeMetrics: React.SFC<IUserProps> = ({ dispatch, episodeData }) => {

	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [graphOptions, setGraphOptions] = useState({});
	const chartComponentRef = useRef(null);

	const handleRefreshGraph = (data, time) => {
		setGraphOptions({
			chart: {
				type: 'column'
			},
			title: {
				text: ' '
			},
			xAxis: {
				categories: time
			},
			yAxis: {
				min: 0,
				title: {
					text: 'Number Of User Episodes'
				}
			},
			plotOptions: {
				series: {
					allowPointSelect: false,

				}
			},
			series: [{
				name: 'User Episodes',
				data: [...data],
				dataLabels: {
					enabled: false,
				},
			}]

		});
	};

	React.useEffect(() => {
		dispatch(episodeAction.episodeUserMetric());
	}, []);

	if (!isDataLoaded && episodeData && !episodeData.isApiLoading && episodeData.isApiSuccess) {
		setIsDataLoaded(true);
		if (episodeData.items.length > 0) {
			var data: number[] = [];
			var time: string[] = [];
			episodeData.items.forEach((item) => {
				const localTime = moment.utc(item.dateTime).local() // Convert from UTC to local browser time
				data.push(item.users)
				time.push(moment(localTime).format('hh A'))
			});
			handleRefreshGraph(data, time);
		}
	}

	return (
		<div className="azure-user-metric">
			<h5 data-testid="userMetricsTitle">User Episode Metrics</h5>
			<div className='card-box'>
				<div className='card-box-graph' data-testid="userMetricsChart">
					{episodeData && episodeData.isApiLoading ? <DABInlineLoading /> :
						episodeData && episodeData.items && episodeData.items.length > 0 ?
							<HighchartsReact
								containerProps={{ style: { height: "100%", width: "100%", padding: "0" } }}
								highcharts={Highcharts}
								options={graphOptions}
								ref={chartComponentRef}
							/> :
							<div className="card-box on-empty"><h5 className="text-center">No data found</h5></div>}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { episodeData } = state;
	return { episodeData };
};

export default connect(mapStateToProps)(UserEpisodeMetrics);